import { Box, Button, Checkbox, TextField } from '@mui/material'
import { MobileDatePicker } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import React, { useContext, useEffect, useState } from 'react'
import Page from '../../component/Page'
import { PLAN_CONFIG } from './config';
import PlanContext from './services/planApi';
import api from '../../api/api'
import ConfirmDialogPlandelivery from './component/confirmDialogPlandelivery';
import ConfirmPlanPrint from './component/confirmPlanPrint';
import Swal from 'sweetalert2';

const BrowserInput = function BrowserInput(props) {
    const { inputProps, InputProps, ownerState, value, inputRef, error, ...other } = props;
    return (
        <TextField {...inputProps} ref={inputRef} value={value ? value.substring(0, value?.length - 6) + (parseInt(value?.substring(value?.length - 6)) + 543).toString() : null} {...other} variant="standard" fullWidth
            InputProps={{
                disableUnderline: true,
            }}
        />
    );
};
export default function Delivery() {
    const { getPlanDelivery } = useContext(PlanContext);
    const [data, setData] = useState([])
    const [date, setDate] = useState(dayjs())
    const [rows, setRows] = useState([])
    const [open, setOpen] = useState(false)
    const [openP, setOpenP] = useState(false)
    useEffect(() => {
        const newDate = date ? dayjs(date).format('YYYY-MM-DD') : null
        getPlanDelivery(newDate, setData)
    }, [date])
    useEffect(() => {
        if (data.length > 0) {
            data.forEach(x => {
                const rd = new Date(x.DocumentDate);
                const year = rd.getFullYear() + 543;
                const day = rd.getDate();
                const m = rd.getMonth();
                const dateThai = new Date(year, m, day);
                x.DocumentDate = dateThai;
                // x.Cost = x.Cost ? this.currencyPipe.transform(x.Cost.toString()) : 0;
                x.Distance = x.Distance ? x.Distance.toString() : 0;
                x.CostPerKM = x.CostPerKM ? x.CostPerKM : 0;
                x.Cost = x.Cost ? x.Cost : 0;
                // x.CostPerKM = x.CostPerKM ? x.CostPerKM.toLocaleString('TH', {
                //   minimumFractionDigits: 2,
                //   maximumFractionDigits: 2
                // }) : 0.00;
                // x.Cost = x.Cost ? x.Cost.toLocaleString('TH', {
                //   minimumFractionDigits: 2,
                //   maximumFractionDigits: 2
                // }) : 0.00;
                x.carType = {
                    private: x?.DeliveryType === 'รถเอกชน' ? true : false,
                    personal: x?.DeliveryType === 'รถศูนย์' ? true : false,
                }
            })
        }


        setRows(data);
    }, [data])

    const handleSubmit = () => {
        const body = {
            DeliveryCosts: rows?.map((x) => ({
                ...x,
                DeliveryType: x?.carType?.private === true ? 'รถเอกชน' : x?.carType?.personal === true ? 'รถศูนย์' : '',
                DocumentDate: dayjs(x?.DocumentDate).format('YYYY-MM-DD'),
                CostPerKM: +x?.CostPerKM.toString().replaceAll(',', ''),
                Cost: +x?.Cost.toString().replaceAll(',', ''),
                Distance: +x?.Distance.toString().replaceAll(',', '')

            }))
        }
        const planDeliveryAdd = async () => {
            const res = await api.post(PLAN_CONFIG.requests.getPlanDelivery.url, body)
            const data = res.data
            if (data.status === true) {
                setOpen(false)
                setOpenP(true)
            }
            else {
                Swal.fire({
                    title: data?.message || 'ทำรายการไม่สำเร็จ',
                    icon: 'warning',
                })
            }
        }
        planDeliveryAdd()
    }
    return (
        <Page>
            <form >
                <div class="container-fluid">
                    <div class="d-flex row align-items-center ">
                        <div class="col-12">
                            <label class="title-content mb-4">
                                ข้อมูลสรุปผลการจัดส่งเมล็ดพันธุ์
                            </label>
                        </div>

                    </div>

                    <div class="row">

                        <div class="col-lg-4 col-md-12 ">
                            <label class="labelInput">วันที่</label>
                            <Box className='backgroundField' sx={{ margin: '10px 0px' }}>
                                <MobileDatePicker
                                    dayOfWeekFormatter={(day) => `${day}`}
                                    value={date} onChange={e => setDate(e)}
                                    slotProps={{ textField: { variant: 'standard', fullWidth: true, InputProps: { disableUnderline: true }, value: date } }}
                                    slots={{
                                        textField: BrowserInput,
                                    }}
                                />
                            </Box>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12 table-responsive-sm pb-3" style={{ height: 'auto' }}>
                            <table class="table table-bordered table-hover ">
                                <thead>
                                    <tr>
                                        <th scope="col " rowspan="2" class="text-center" style={{ width: '10%' }}>
                                            วัน/เดือน/ปี<br />ที่จัดส่ง</th>
                                        <th scope="col " rowspan="2" class="text-center">เลขที่ DOI</th>
                                        <th scope="col " colspan="2" class="text-center">จัดส่งโดย</th>
                                        <th scope="col " rowspan="2" class="text-center">หมายเหตุ</th>
                                        <th scope="col " rowspan="2" class="text-center">ค่าจ้างขนส่ง/กิโลกรัม</th>

                                        <th scope="col " rowspan="2" class="text-center">ค่าน้ำมัน</th>

                                        <th scope="col " colspan="3" class="text-center">ผู้รับจ้างขนส่ง</th>

                                        <th scope="col " rowspan="2" class="text-center">ประมาณระยะทาง (กิโลเมตร)</th>

                                    </tr>
                                    <tr>

                                        <th scope="col " class="text-center">รถเอกชน</th>
                                        <th scope="col " class="text-center">รถศูนย์</th>

                                        <th scope="col " class="text-center">ชื่อบริษัท/ร้าน</th>
                                        <th scope="col " class="text-center">ที่อยู่</th>
                                        <th scope="col " class="text-center">เบอร์โทรศัพท์</th>

                                    </tr>

                                </thead>
                                <tbody class="">
                                    {rows?.map((x, i) => (
                                        <tr >
                                            <td class="text-center" style={{ verticalAlign: 'middle' }}>{dayjs(x?.DocumentDate).format('DD-MM-YYYY')}</td>
                                            <td class="text-center" style={{ verticalAlign: 'middle' }}>{x?.DoiNo}</td>
                                            <td class="text-center cp">
                                                <Checkbox checked={x?.carType?.private} onChange={e => {
                                                    const item = rows?.map((v, index) => {
                                                        v.carType.private = index === i ? e.target.checked : v.carType.private;
                                                        v.carType.personal = index === i ? e.target.checked === true ? !e.target.checked : false : v.carType.personal;
                                                        return v;

                                                    });
                                                    setRows([...item]);
                                                }} />
                                            </td>
                                            <td class="text-center cp">
                                                <Checkbox checked={x?.carType?.personal} onChange={e => {

                                                    const item = rows?.map((v, index) => {


                                                        v.carType.private = index === i ? e.target.checked === true ? !e.target.checked : false : v.carType.private;
                                                        v.carType.personal = index === i ? e.target.checked : v.carType.personal;
                                                        return v;

                                                    });
                                                    setRows([...item]);
                                                }} />
                                            </td>
                                            <td>
                                                {x?.carType?.personal || x?.carType?.private ?
                                                    <TextField value={x?.Remark} size='small' fullWidth variant='outlined' onChange={e => {
                                                        const item = rows?.map((v, index) => {
                                                            v.Remark = index === i ? e.target.value : v?.Remark;
                                                            return v;

                                                        });
                                                        setRows([...item]);
                                                    }} /> : null
                                                }
                                            </td>
                                            <td>
                                                {x?.carType?.private &&
                                                    <TextField value={!x?.CostPerKM?.toString()?.includes(',') && +x?.CostPerKM > 999  ? (+x?.CostPerKM).toLocaleString('en-US') : x?.CostPerKM || ''} size='small' fullWidth variant='outlined' onChange={e => {
                                                        let inputValue = e.target.value.replace(/[^0-9.]/g, ''); // Remove non-numeric characters
                                                        // Split the number into integer and decimal parts
                                                        const [integerPart, decimalPart] = inputValue.toString().split('.');

                                                        // Format the integer part with commas
                                                        const formattedInteger = parseFloat(integerPart || 0).toLocaleString('en-US');

                                                        // Combine the integer and decimal parts with a dot
                                                        const formattedNumber = decimalPart !== undefined
                                                            ? `${formattedInteger}.${decimalPart}`
                                                            : formattedInteger;

                                                        const item = rows?.map((v, index) => {
                                                            v.CostPerKM = index === i ? formattedNumber : v?.CostPerKM;
                                                            return v;

                                                        });
                                                        setRows([...item]);
                                                    }}

                                                    />}
                                            </td>
                                            <td>
                                                {x?.carType?.personal &&
                                                    <TextField value={!x?.Cost?.toString()?.includes(',')  && +x?.Cost > 999 ? (+x?.Cost).toLocaleString('en-US') : x?.Cost || ''} size='small' fullWidth variant='outlined' onChange={e => {
                                                        let inputValue = e.target.value.replace(/[^0-9.]/g, ''); // Remove non-numeric characters

                                                        // Split the number into integer and decimal parts
                                                        const [integerPart, decimalPart] = inputValue.toString().split('.');

                                                        // Format the integer part with commas
                                                        const formattedInteger = parseFloat(integerPart || 0).toLocaleString('en-US');

                                                        // Combine the integer and decimal parts with a dot
                                                        const formattedNumber = decimalPart !== undefined
                                                            ? `${formattedInteger}.${decimalPart}`
                                                            : formattedInteger;

                                                        const item = rows?.map((v, index) => {
                                                            v.Cost = index === i ? formattedNumber : v?.Cost;
                                                            return v;

                                                        });
                                                        setRows([...item]);
                                                    }}
                                                    />}
                                            </td>
                                            {/* <td>
                                                <TextField value={x?.Distance} size='small' fullWidth variant='outlined' onChange={e => {
                                                    const item = rows?.map((v, index) => {
                                                        v.Distance = index === i ? e.target.value : v?.Distance;
                                                        return v;

                                                    });
                                                    setRows([...item]);
                                                }} />
                                            </td> */}
                                            <td>
                                                {x?.carType?.private &&
                                                    <TextField value={x?.CompanyName} size='small' fullWidth variant='outlined' onChange={e => {
                                                        const item = rows?.map((v, index) => {
                                                            v.CompanyName = index === i ? e.target.value : v?.CompanyName;
                                                            return v;

                                                        });
                                                        setRows([...item]);
                                                    }} />}
                                            </td>
                                            <td>
                                                {x?.carType?.private &&
                                                    <TextField value={x?.CompanyAddress} size='small' fullWidth variant='outlined' onChange={e => {
                                                        const item = rows?.map((v, index) => {
                                                            v.CompanyAddress = index === i ? e.target.value : v?.CompanyAddress;
                                                            return v;

                                                        });
                                                        setRows([...item]);
                                                    }} />}
                                            </td>
                                            <td> {x?.carType?.private &&
                                                <TextField value={x?.CompanyTel} size='small' fullWidth variant='outlined' onChange={e => {
                                                    const item = rows?.map((v, index) => {
                                                        v.CompanyTel = index === i ? e.target.value : v?.CompanyTel;
                                                        return v;

                                                    });
                                                    setRows([...item]);
                                                }} />}
                                            </td>
                                            <td>
                                                {x?.carType?.personal || x?.carType?.private ?
                                                    <TextField value={!x?.Distance?.toString()?.includes(',')  && x?.Distance > 999  ? (+x?.Distance).toLocaleString('en-US') : x?.Distance || ''} size='small' fullWidth variant='outlined' onChange={e => {
                                                        let inputValue = e.target.value.replace(/[^0-9.]/g, ''); // Remove non-numeric characters

                                                        // Split the number into integer and decimal parts
                                                        const [integerPart, decimalPart] = inputValue.split('.');

                                                        // Format the integer part with commas
                                                        const formattedInteger = parseFloat(integerPart || 0).toLocaleString('en-US');

                                                        // Combine the integer and decimal parts with a dot
                                                        const formattedNumber = decimalPart !== undefined
                                                            ? `${formattedInteger}.${decimalPart}`
                                                            : formattedInteger;

                                                        const item = rows?.map((v, index) => {
                                                            v.Distance = index === i ? formattedNumber : v?.Distance;
                                                            return v;

                                                        });
                                                        setRows([...item]);
                                                    }}
                                                    /> : null}
                                            </td>
                                        </tr>
                                    ))}

                                </tbody>
                            </table>
                        </div>


                    </div>


                    <hr class="chr" />
                    <div class="row mt-4">
                        <div class="col-12 ">
                            <Button type="button" class="ButtomSearch" onClick={() => {
                                if (rows?.length === 0) {
                                    Swal.fire({
                                        icon: 'error',
                                        title: 'ไม่พบข้อมูล Dois',
                                    })
                                } else {
                                    setOpen(true)
                                }
                            }}>บันทึก</Button>

                        </div>
                    </div>
                </div>
            </form>
            <ConfirmDialogPlandelivery open={open} setOpen={setOpen} rows={rows} handleAdd={handleSubmit} />
            <ConfirmPlanPrint title={'บันทึกข้อมูลผลสรุปการจัดส่งเมล็ดพันธุ์สำเร็จ'} download={null} open={openP} setOpen={setOpenP} loadingPDF={null} linkTo='/plan/delivery' />
        </Page>
    )
}
